import { FC, useState, useEffect } from 'react';
import { Field, Form, HelperText, Label } from '../../Registration.styles';
import { Dropdown, Input, Loading, Message, Modal } from '../../../../components';
import { RegistrationFormPage } from '../../templates';
import { Box, Typography } from '@mui/material';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
// [REFACTOR] hook movido do Router.tsx para cá — API só carrega ao acessar esta view
import { usePushEmail } from '../../../../utils/hooks/useEmailPush';


function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary' }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}



// [REFACTOR] props removidas — agora o hook é consumido internamente
const PushEmailCustom: FC = () => {
  const {
    handlePushEmail,
    setMessage,
    setGreeting,
    setFarewell,
    setTitle,
    message,
    greeting,
    farewell,
    title,
    loading,
    userTypeOptions,
    revendaNotificationOptions,
    concessionariaNotificationOptions,
    handleUserTypeChange,
    handleNotificationChange,
    userType,
    notificationType,
    handleUserTypeChangeStatus,
    userTypeStatus,
    userTypeStatusOptions,
    emailProgress,
    isSending,
    timeLeft,
    emailsSentCount,
    totalRecipients,
  } = usePushEmail();
  const isPush = notificationType === 'enviarPush';
  
  const [dots, setDots] = useState(".......");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 7 ? prev + "." : ""));
    }, 500);
    return () => clearInterval(interval);
  }, []); 

  // const DemoPaper = styled(Paper)(({ theme }) => ({
  //   width: 150,
  //   height: 50,
  //   padding: theme.spacing(1),
  //   ...theme.typography.body2,
  //   textAlign: 'center',
  // }));

  // const formatTime = (timeInMillis:number) => {
  //   const minutes = Math.floor(timeInMillis / 60000);
  //   const seconds = Math.floor((timeInMillis % 60000) / 1000);
  //   return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  // };

  <style>
  {`
    @media (max-width: 600px) {
      .modal-content {
        flex-direction: column;
        align-items: flex-start;
      }
    }
  `}
</style>



  if (loading) return <Loading fullScreen />;

  return (
    <RegistrationFormPage title='Envio de Push e E-mails' onSubmit={handlePushEmail}>

    {isSending && (
          <Modal  
          open={true}
          onClose={() => {}}
          title={isPush ? 'Processando o envio de push' : 'Processando o envio de e-mails'}>            
              <div className="modal">
                    <div className="modal-content">
                        <h3>{isPush ? 'Enviando Push' : 'Enviando E-mails'}<span>{dots}</span></h3>
                        {/* <Box
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            padding:"10px 0px",
                              '& > :not(style)': {
                              m: 0,
                              width: 200,
                              height: 80,
                            },
                          }}
                        >
                         <Stack direction="row" display={'flex'} flexDirection={'column'} spacing={0.5}>
                          <DemoPaper style={{fontSize:"20px"}} variant="outlined">{formatTime(timeLeft)}</DemoPaper>
                          <div style={{flexDirection:"row", display:"flex"}}>
                          <AccessAlarmsIcon style={{margin:"10px 0px"}} />
                          <p style={{fontSize:"16px", textAlign:"center", margin:"12px 4px"}}>Tempo restante</p>
                          </div>
                        </Stack>
                        </Box> */}
                        <div style={{
                          display: "flex",
                          gap: "5px", // afasta os elementos
                          marginRight: "67px",
                          marginBottom: "60px",
                          position: "absolute",
                          right: 0,
                          bottom: 0
                        }}>
                          <p>Enviado</p>
                          <b>{emailsSentCount}</b>
                          <p>de</p>
                          <b>{totalRecipients}</b>
                        </div>

                        
                        <Box sx={{ width: '100%' }}>
                        <LinearProgressWithLabel sx={{background:"none rgb(255, 102, 0)"}} value={emailProgress} />
                      </Box>
                    </div>
                </div>
          </Modal>
     )}  




      <Form>
        <Label>Enviar para</Label>
        <Field>
          <Dropdown
            options={userTypeOptions}
            selected={userTypeOptions.find((opt) => opt.value === userType)}
            onSelect={handleUserTypeChange}
          />
        </Field>
        <Label>Enviar para</Label>
        <Field>
          <Dropdown
            options={userTypeStatusOptions}
            selected={userTypeStatusOptions.find((opt) => opt.value === userTypeStatus)}
            onSelect={handleUserTypeChangeStatus}
            icon={true}
            

          />
        </Field>
        <Label>Tipo de Notificação</Label>
        <Field>
          <Dropdown
            options={
              userType === 'revendas'
                ? revendaNotificationOptions
                : concessionariaNotificationOptions
            }
            selected={
              (userType === 'revendas'
                ? revendaNotificationOptions
                : concessionariaNotificationOptions
              ).find((opt) => opt.value === notificationType)
            }
            onSelect={handleNotificationChange}
          />
        </Field>
        <Label>Título</Label>
        <Field>
          <Input
            variant='text'
            placeholder='Título'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
		  <HelperText>Se for push notification, lembre de ser um título pequeno e resumido.</HelperText>
        </Field>
        <Label>Mensagem</Label>
        <Field>
			<Message
				placeholder='Mensagem'
				value={message}
            onChange={(e) => setMessage(e.target.value)}
			/>
		  <HelperText>Se for push notification, lembre de ser uma mensagem pequena e resumida.</HelperText>
        </Field>
        {/* {notificationType === 'enviarEmail' && (
          <>
            <Label>Cumprimento E-mail</Label>
            <Field>
              <Input
                variant='text'
                placeholder='Cumprimento no e-mail'
                value={greeting}
                onChange={(e) => setGreeting(e.target.value)}
              />
			  <HelperText>Exemplo: "Prezado lojista Parceiro,"</HelperText>
            </Field>
            <Label>Despedida E-mail</Label>
            <Field>
              <Input
                variant='text'
                placeholder='Despedida no e-mail'
                value={farewell}
                onChange={(e) => setFarewell(e.target.value)}
              />
			  <HelperText>Exemplo: "Estamos à disposição para qualquer dúvida. Boas compras e bons negócios!"</HelperText>
            </Field>
          </>
        )} */}
      </Form>
    </RegistrationFormPage>
  );
};

export default PushEmailCustom;
